import React from 'react';
import { toast } from 'react-toastify';
const toastMethods = {
    success: toast.success,
    info: toast.info,
    warning: toast.warn,
    error: toast.error,
    default: toast
};
/**
 * Helper to dispatch the notification from anywhere
 */
export const broadcastNotification = (detail) => {
    if (process.env.NODE_ENV !== 'production') {
        window.dispatchEvent(new CustomEvent('app-notification', { detail }));
    }
};
const setupNotifications = () => {
    if (process.env.NODE_ENV === 'production')
        return;
    window.addEventListener('app-notification', (event) => {
        const customEvent = event;
        const { title, details, type = 'error', autoClose = 8000 } = customEvent.detail;
        const message = details && typeof details === 'object'
            ? Object.keys(details)
                .map((key) => {
                const val = details[key];
                const displayVal = Array.isArray(val) ? val.join(', ') : val;
                return `• ${key}: ${displayVal}`;
            })
                .join('\n')
            : details;
        const toastFn = toastMethods[type];
        toastFn(React.createElement("div", { style: { width: '100%' } },
            React.createElement("strong", { style: { fontSize: '13px' } }, title),
            message && (React.createElement("pre", { style: {
                    background: 'rgba(0,0,0,0.1)',
                    border: 'none',
                    color: 'inherit',
                    fontSize: '11px',
                    marginTop: '8px',
                    padding: '5px',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    fontFamily: 'monospace'
                } }, message))), {
            position: 'top-right',
            autoClose,
            draggable: false
        });
    });
};
export default setupNotifications;



//////////////////
// WEBPACK FOOTER
// ./src/setupNotifications.tsx
// module id = 1143
// module chunks = 0